import AgoraRTC from "agora-rtc-sdk-ng"
import { handleLocalStorage } from '@/assets/js/utils.js'
import protoRoot from '@/assets/js/SttMessage_es6.js'
import $Store from '@/store/index.js'

AgoraRTC.setLogLevel(2)
// AgoraRTC.setParameter("ENABLE_VIDEO_SEI", true)

export default class RTCClient {
  constructor () {
    this._client = null
    this._joinParams = {}
    this._deviceInfo = {}
    this._callbackEnume = {}
    this._remotePublishUser = {}
    this._role = 'audience'
    this._AgoraRTC = AgoraRTC
    this._localVideoTrack = null
    this._localAudioTrack = null
    this._localShareTrack = null
    this._networkIntervalTimer = null
    this._connectStatus = 'CONNECTING'
    // 添加自动监听
    this.listenIsAutoplayFailed()
    this.listenCameraChange()
    this.listenMicChange()
    this.listenPlaybackChange()
  }

  on (event, callback) {
    this._callbackEnume[event] = callback
  }

  listenIsAutoplayFailed () {
    AgoraRTC.onAutoplayFailed = () => {
      this._callbackEnume['autoplayFailed'] && this._callbackEnume['autoplayFailed']()
    }
  }

  listenCameraChange () {
    AgoraRTC.onCameraChanged = async (changeDevice) => {
      const videoTrack = this._localVideoTrack
      const { cameraList } = await this.getCameras()
      const { state, device } = changeDevice
      const switchInfo = {
        result: '',
        deviceId: '',
        cameraList
      }
      /**
       * 如果拔掉正常使用的摄像头，先去查找列表是否有 default 设备如果没有在使用设备列表第一个
       * 如果当前没有创建成功videoTack，并且这时有新设备加入，则创建新的videotrack并切换到此设备上
       */
      if (state === 'INACTIVE' && videoTrack && videoTrack._deviceName.includes(device.label) && cameraList.length) {
        const newDevice = cameraList.find(item => item.deviceId === 'default') || cameraList[0]
        const newDevicesId = newDevice.deviceId
        console.log('INACTIVE list: ', cameraList)
        await this.setDevice(newDevicesId, 'video', (result) => {
          switchInfo.result = result
          if (result === 'success') switchInfo.deviceId = newDevicesId
        })
      } else if (state === 'ACTIVE' && !videoTrack) {
        try {
          await this.createCameraTrack(device.deviceId)
          switchInfo.result = 'success'
          switchInfo.deviceId = device.deviceId
        } catch (error) {
          switchInfo.result = 'failed'
        }
      }
      this._callbackEnume['cameraChange'] && this._callbackEnume['cameraChange'](switchInfo)
    }
  }

  listenMicChange () {
    AgoraRTC.onMicrophoneChanged = async (changeDevice) => {
      const audioTrack = this._localAudioTrack
      const { microphoneList } = await this.getMicrophones()
      const { state, device } = changeDevice
      const switchInfo = {
        result: '',
        deviceId: '',
        microphoneList
      }
      /**
       * 如果拔掉当前正在使用的麦克风，则切先查找是否有default设备如果有优先使用default，没有再去用设备列表第一个
       * 如果当前使用的是 default 设备，这时新插入一个设备则重新切换到 default 设备
       * 如果当前没有audiotrack并且有新设备添加则切换到这个新设备
       */
      console.log('microphonesChange: ', microphoneList)
      if (state === 'INACTIVE' && audioTrack && audioTrack._deviceName.includes(device.label) && microphoneList.length) {
        const newDevice = microphoneList.find(item => item.deviceId === 'default') || microphoneList[0]
        const newDevicesId = newDevice.deviceId
        console.log('INACTIVE list: ', microphoneList)
        await this.setDevice(newDevicesId, 'audio', (result) => {
          switchInfo.result = result
          if (result === 'success') switchInfo.deviceId = newDevicesId
        })
      } else if (state === 'ACTIVE' && audioTrack?._config?.microphoneId == 'default') {
        const newDeviceGroupId = device.groupId
        const newDeviceIsDefault = microphoneList.find(item => item.groupId === newDeviceGroupId && item.deviceId === 'default')
        if (newDeviceIsDefault?.deviceId) {
          await this.setDevice('default', 'audio', (result) => {
            switchInfo.result = result
            if (result === 'success') switchInfo.deviceId = 'default'
          })
        }
      } else if (state === 'ACTIVE' && !audioTrack) {
        try {
          await this.createMicrophoneTrack()
          switchInfo.result = 'success'
          switchInfo.deviceId = device.deviceId
        } catch (error) {
          switchInfo.result = 'failed'
        }
      }
      this._callbackEnume['microphonesChange'] && this._callbackEnume['microphonesChange'](switchInfo)
    }
  }

  listenPlaybackChange () {
    AgoraRTC.onPlaybackDeviceChanged = async (changeDevice) => {
      this._callbackEnume['playbackChange'] && this._callbackEnume['playbackChange'](changeDevice)
    }
  }

  addEventsListener () {
    // 和 Agora 服务器连接的回调
    this._client.on('connection-state-change', (curState, revState, reason) => {
      this._connectStatus = curState
      this._callbackEnume['connection-state-change'] && this._callbackEnume['connection-state-change'](reason)

    })
    // 有主播加入进来的回调，观众不会走这个
    this._client.on('user-joined', (user) => {
      this._callbackEnume['user-joined'] && this._callbackEnume['user-joined'](user)
    })
    // 有主播离开的回调
    this._client.on('user-left', (user, reason) => {
      const { uid } = user
      this._remotePublishUser[uid] && delete this._remotePublishUser[uid]
      this._callbackEnume['user-left'] && this._callbackEnume['user-left'](user, reason)
    })
    // 远端用户发布了流的回调
    this._client.on('user-published', (remoteUser, mediaType) => {
      const { uid } = remoteUser
      this._remotePublishUser[uid] = remoteUser
      this._callbackEnume['user-published'] && this._callbackEnume['user-published'](remoteUser, mediaType)
    })
    // 远端用户取消发布流的回调
    this._client.on('user-unpublished', (remoteUser, mediaType) => {
      const { uid } = remoteUser
      this._remotePublishUser[uid] = remoteUser
      this._callbackEnume['user-unpublished'] && this._callbackEnume['user-unpublished'](remoteUser, mediaType)
    })
    // 远端说话的内容
    this._client.on('stream-message', (uid, message) => {
      const textInfo = protoRoot.Agora.SpeechToText.lookup('Text').decode(message)
      this._callbackEnume['stream-message'] && this._callbackEnume['stream-message']({ id: uid, textInfo })
    })
    // 返回本地用户的上下行带宽
    this._client.on('network-quality', qualityInfo => {
      this._callbackEnume['network-quality'] && this._callbackEnume['network-quality'](qualityInfo)
    })
  }

  async getDevice () {
    const cameraInfo = await this.getCameras()
    const microphoneInfo = await this.getMicrophones()
    const playbackInfo = await this.getPalybackDevices()
    return {
      ...cameraInfo,
      ...microphoneInfo,
      ...playbackInfo
    }
  }

  async getCameras () {
    let obj = {
      cameraId: null,
      cameraList: [],
      cameraError: ''
    }
    const cameraId = handleLocalStorage('get', 'cameraId')
    try {
      obj.cameraList = await AgoraRTC.getCameras()
      obj.cameraList.forEach(item => {
        if (item.deviceId === cameraId) obj.cameraId = item.deviceId
      })
      // 如果当前设备已经不存在则换成列表第一个设备
      obj.cameraId ??= obj.cameraList[0]?.deviceId
      return obj
    } catch (error) {
      console.log(error)
      obj.cameraError = error.code
      return obj
    }
  }

  async getMicrophones () {
    let obj = {
      microphoneId: null,
      microphoneList: [],
      microphoneError: ''
    }
    const microphoneId = handleLocalStorage('get', 'microphoneId')
    try {
      obj.microphoneList = await AgoraRTC.getMicrophones()
      obj.microphoneList.forEach(item => {
        if (item.deviceId === microphoneId) obj.microphoneId = item.deviceId
      })
      obj.microphoneId ??= obj.microphoneList[0]?.deviceId
      return obj
    } catch (error) {
      console.log(error)
      obj.microphoneError = error.code
      return obj
    }
  }

  async getPalybackDevices () {
    let obj = {
      speakerId: null,
      speakerList: []
    }
    let speakerId = handleLocalStorage('get', 'speakerId')
    try {
      obj.speakerList = await AgoraRTC.getPlaybackDevices()
      obj.speakerList.forEach(item => {
        if (item.deviceId === speakerId) obj.speakerId = item.deviceId
      })
      obj.speakerId ??= obj.speakerList[0]?.deviceId
      return obj
    } catch (error) {
      console.log(error)
      return obj
    }

  }

  async setDevice (deviceId, mediaType, callback) {
    // todo
    // if (type === 'video') {
    //   $Store.state.initCamera = true
    //   $Store.state.showInitCameraTips = false
    // }
    // 如果当前切换的是 camera 并且之前还没有创建成功过 videoTrack， 则根据当前的 deviceId 创建 videoTrack
    if (mediaType === 'video' && !this._localVideoTrack) {
      try {
        const videoTrack = await createCameraTrack(deviceId)
        videoTrack?.play('local_stream', { mirror: true })
        handleLocalStorage('set', 'cameraId', deviceId)
        callback && callback('success')
      } catch (error) {
        console.log(error)
        callback && callback('failed')
      }
    }

    if (mediaType === 'video' && this._localVideoTrack) {
      try {
        await this._localVideoTrack.setDevice(deviceId)
        handleLocalStorage('set', 'cameraId', deviceId)
        callback && callback('success')
        // this.setSolution() todo
      } catch (error) {
        callback && callback('failed')
        console.log(error)
      }
    }
    // 如果当前切换的是 audio 并且之前还没有创建成功过 audioTrack， 则根据当前的 deviceId 创建 audioTrack
    if (mediaType === 'audio' && !this._localAudioTrack) {
      const audioTrack = await this.createMicrophoneTrack(deviceId)
      if (audioTrack) {
        if (this._role !== 'host') {
          await this._client.setClientRole('host')
          this._role = 'host'
          this._client.publish([audioTrack])
          callback && callback('success')
        }
      } else {
        callback && callback('failed')
      }
    }

    if (mediaType === 'audio' && this._localAudioTrack) {
      try {
        await this._localAudioTrack.setDevice(deviceId)
        handleLocalStorage('set', 'microphoneId', deviceId)
        callback && callback('success')
      } catch (error) {
        callback && callback('failed')
        console.log(error)
      }
    }
  }

  createClient (mode, codec) {
    this._client = AgoraRTC.createClient({ mode: mode || 'live', codec: codec || 'vp8' })
  }

  async join (params) {
    const { mode, codec, token, appId, channel, uid, audio, video, share, getRemoteNetworks, startProxy, publishAudio, publishVideo, publish } = params
    this._joinParams = params
    this.createClient(mode, codec)
    if (startProxy) this._client.startProxyServer(3)
    try {
      const uidVal = await this._client.join(appId, channel, token, uid)
      this.addEventsListener()
      if (getRemoteNetworks) this.getRemoteNetworks()
      const trackPromises = []
      if (video) trackPromises.push(this.createCameraTrack())
      if (audio) trackPromises.push(this.createMicrophoneTrack())
      if (share) trackPromises.push(this.createShareTrack())
      await Promise.all(trackPromises)
      this._localVideoTrack && this._localVideoTrack.play('local_stream')
      this._callbackEnume['getLocalTrack']?.({ videoTrack: this._localVideoTrack, audioTrack: this._localAudioTrack })
      if (publish != false) {
        await this._client.setClientRole("host")
        this._role = 'host'
        await this._client.publish(share ? [this._localShareTrack] : [this._localVideoTrack, this._localAudioTrack].filter(item => item))
      }
      return uidVal
    } catch (error) {
      console.log(error)
    }
  }

  async createCameraTrack (deviceId) {
    const { cameraId, videoConfig } = this._joinParams
    try {
      this._localVideoTrack = await AgoraRTC.createCameraVideoTrack({
        cameraId: deviceId || cameraId,
        encoderConfig: !videoConfig ? '360p' : {
          // 视频分辨率
          width: videoConfig[0].width,
          height: videoConfig[0].height,
          // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
          frameRate: {
            min: 15,
            max: videoConfig[0].fps
          },
          bitrateMin: videoConfig[0].bitrate,
          bitrateMax: videoConfig[0].bitrate
        }
      })
      return this._localVideoTrack
    } catch (error) {
      console.log(error)
    }
  }

  async createMicrophoneTrack (deviceId) {
    const { microphoneId } = this._joinParams
    try {
      this._localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
        AEC: handleLocalStorage('get', 'checkedAec') ? JSON.parse(handleLocalStorage('get', 'checkedAec')) : true, //回声消除
        ANS: handleLocalStorage('get', 'checkedAns') ? JSON.parse(handleLocalStorage('get', 'checkedAns')) : true, //噪声抑制
        AGC: handleLocalStorage('get', 'checkedAgc') ? JSON.parse(handleLocalStorage('get', 'checkedAgc')) : true,  //麦克风增强
        microphoneId: deviceId || microphoneId,
        encoderConfig: handleLocalStorage('get', 'audioQualityPreset') || 'high_quality'
      })
      return this._localAudioTrack
    } catch (error) {
      console.log(error)
    }
  }

  async createShareTrack () {
    const { status } = this._joinParams
    const { shareScreenBitrate, shareScreenFrameRate, shareScreenResolution } = status
    // const setBitrate = Number(shareScreenBitrate || 2000)
    const params = shareScreenBitrate && shareScreenFrameRate && shareScreenResolution ? {
      width: 1920,
      height: 1080,
      fps: 15,  // 30 FPS 太高可能会影响自己发送端网络的稳定，因为目前代码还是会订阅自己的 sharescreen
      bitrateMax: 6000,
      bitrateMin: 2000
    } : '1080p_2'
    try {
      this._localShareTrack = await AgoraRTC.createScreenVideoTrack({
        encoderConfig: params
      })
      this.shareEventListener()
      const isArray = Array.isArray(this._localShareTrack)
      this._callbackEnume['start-share'] && this._callbackEnume['start-share']({
        channel: this._joinParams.channel,
        rtilCode: this._joinParams.uid,
        shareInfo: {
          videoTrack: isArray ? this._localShareTrack[0] : this._localShareTrack,
          audioTrack: isArray ? this._localShareTrack[1] : null
        }
      })
      await this._client?.setClientRole("host")
      this._role = 'host'
      //todo callback 和 publish
      return this._localShareTrack
    } catch (error) {
      console.log(error)
      this._callbackEnume['stop-share'] && this._callbackEnume['stop-share'](this._joinParams.uid)
    }
  }

  shareEventListener () {
    let { uid } = this._joinParams
    // 判断当前shareTrack是对象还是数组
    if (Object.prototype.toString.call(this._localShareTrack) === '[object Object]') {
      this._localShareTrack.on('track-ended', () => {
        this.leave()
        this._callbackEnume['stop-share'] && this._callbackEnume['stop-share'](uid)
      })
    } else {
      const _this = this
      this._localShareTrack.forEach(track => {
        if (track.trackMediaType === 'video') {
          track.on('track-ended', () => {
            _this.leave()
            this._callbackEnume['stop-share'] && this._callbackEnume['stop-share'](uid)
          })
        }
      })
    }
  }

  replay () {
    if (this._localVideoTrack) {
      this._localVideoTrack.play(`${this._joinParams.domId || 'local_stream'}`, {
        mirror: true
      })
    }
  }

  play (mediaTrack, params, callback) {
    if (!mediaTrack) return
    const { mediaType, videoBox, playerConfig } = params
    if (mediaType === 'video') {
      if (videoBox) videoBox.innerHTML = ''
      mediaTrack.play?.(videoBox ? videoBox : 'local_stream', playerConfig ? playerConfig : '')
      callback && callback()
    } else {
      mediaTrack.play?.()
    }
  }

  stop (mediaTrack) {
    if (!mediaTrack) return
    mediaTrack.stop?.()
  }

  async publish (trackArray, callback) {
    if (!trackArray || !trackArray.length || !this._client?._appId) return
    if (this._role !== 'host') {
      await this._client.setClientRole("host")
      this._role = 'host'
    }
    try {
      await this._client.publish(trackArray)
      callback && callback('success')
    } catch (error) {
      callback && callback('failed')
    }
  }

  async unpublish (trackArray) {
    if (!trackArray || !trackArray.length || !this._client?._appId) return
    try {
      await this._client.unpublish(trackArray)
    } catch (error) {
      console.log(error)
    }
  }

  async subscribe (uid, mediaType) {
    // todo  || this._connectStatus != 'CONNECTED'
    if (!this._client?._appId || !this._remotePublishUser[uid]) return
    const remoteUser = this._remotePublishUser[uid]
    // 订阅视频
    if (mediaType == 'video' && remoteUser.hasVideo) await this._client.subscribe(remoteUser, 'video')
    // 订阅音频
    if (mediaType == 'audio' && remoteUser.hasAudio) await this._client.subscribe(remoteUser, 'audio')
    // 订阅音视频
    if (mediaType === 'All') {
      if (remoteUser.hasVideo) await this._client.subscribe(remoteUser, 'video')
      if (remoteUser.hasAudio) await this._client.subscribe(remoteUser, 'audio')
    }
    const { _videoTrack, _audioTrack } = this._remotePublishUser[uid]
    return { videoTrack: _videoTrack, audioTrack: _audioTrack }
  }

  async unSubscribe (uid, mediaType) {
    if (!this._client?._appId || !this._remotePublishUser[uid]) return
    const remoteUser = this._remotePublishUser[uid]
    if (mediaType == 'audio') await this._client.unsubscribe(remoteUser, 'audio')
    if (mediaType == 'video') await this._client.unsubscribe(remoteUser, 'video')
    if (mediaType == 'all') await this._client.unsubscribe(remoteUser)
  }

  async setEnabled (val, type, fun, info = {}) {
    const { controlsMedia } = info
    let flag = true
    if (!this._client?._appId) return
    if (type == 'video' && !this._localVideoTrack && !controlsMedia) {
      if (fun) fun('failed')
      return
    }
    if (type == 'audio' && !this._localAudioTrack && !controlsMedia) {
      if (fun) fun('failed')
      return
    }
    if (type == 'video') {
      if (this._localVideoTrack) {
        this._localVideoTrack.setEnabled(val).then(res => {
          $Store.state.showInitCameraTips = false
        }).catch(() => {
          flag = false
          if (fun) fun('failed')
        })
      } else {
        const videoTrack = await this.createCameraTrack()
        videoTrack && this.publish([videoTrack])
      }
    }
    if (type == 'audio') {
      if (this._localAudioTrack) {
        this._localAudioTrack.setEnabled(status).then(res => {
        }).catch(() => {
          flag = false
          if (fun) fun('failed')
        })
      } else {
        const audioTrack = await this.createMicrophoneTrack()
        audioTrack && this.publish([audioTrack])
      }
    }
    if (fun && flag) fun('success')
  }

  getRemoteNetworks () {
    this._networkIntervalTimer = setInterval(() => {
      const networks = this._client?.getRemoteNetworkQuality()
      if (networks) {
        Object.keys(networks).forEach(id => {
          if (this._callbackEnume['unlinkQuality']) {
            this._callbackEnume['unlinkQuality']({
              id,
              channel: this._params.channel,
              uplinkNetworkQuality: networks[id].uplinkNetworkQuality,
              downlinkNetworkQuality: networks[id].downlinkNetworkQuality,
              type: 'remoteNetWorkQuality'
            })
          }
        })
      }
    })
  }

  getRtcStats () {
    if (this._client) {
      let status = this._client.getRTCStats()
      return status
    }
  }

  setEncoderConfiguration (config) {
    if (!this._localVideoTrack || !this._localVideoTrack._enabled) return
    this._localVideoTrack.setEncoderConfiguration({
      // 视频分辨率
      width: config.width,
      height: config.height,
      // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
      frameRate: config.fps,
      bitrateMin: config.bitrateRange[0],
      bitrateMax: config.bitrateRange[1]
    })
  }

  async leave (closeCLoudProxy) {
    if (!this._client) return
    await this._client.leave()
    if (closeCLoudProxy) this._client.stopProxyServer()
    this._client = null
    clearInterval(this.networksInterval)
    this.networksInterval = null
    if (this._localAudioTrack) {
      this._localAudioTrack.close()
      this._localAudioTrack = null
    }
    if (this._localVideoTrack) {
      this._localVideoTrack.close()
      this._localVideoTrack = null
    }
    if (this._localShareTrack) {
      this._localShareTrack.close()
      this._localShareTrack = null
    }
  }
}
